export const formatPipeUrl = (pipeName, url, path = '/portalserver/proxy') =>
    // eslint-disable-next-line implicit-arrow-linebreak
    `${path}/?pipe=${pipeName}&url=${encodeURIComponent(url)}`;

export const SETTINGS_URL = '/proxy/services/dict-services/serviceProperty/list';
